<kendo-dialog [title]="t7ePopupWorkOnRestdayTitle" (close)="onCancelled()">
  <div class="form-group is-work-on-restday-aapproved">
    <div class="message-details">
      {{ t7eWorkOnRestdayExplanationText }}
    </div>
    <mat-checkbox *ngIf="ALLOW_WORK_ON_REST_DAY" (change)="toggleWorkOnRestdayPreapproved($event.checked)">
      {{ 'work-on-restday-preapproved' | t7e }}
    </mat-checkbox>
  </div>
  <kendo-dialog-actions>
    <button mat-raised-button (click)="onCancelled()">{{ 'cancel' | t7e }}</button>
    <button mat-raised-button (click)="onConfirmed()" color="primary"
      [disabled]="!(isWorkOnRestdayPreapproved$ | async)">OK</button>
  </kendo-dialog-actions>
</kendo-dialog>